
import { format } from 'date-fns';
import { Component, Prop } from 'vue-property-decorator';
import { SalesOrder } from '@/api/model/sales-order';
import Helpers from '@/logic/orders/helpers';
import DashboardStatusBlock from '../content/blocks/DashboardStatusBlock.vue';

@Component
export default class DashboardOrdersBlock extends DashboardStatusBlock {
  @Prop(Object)
  block!: any;

  active = false;

  async created() {
    if (this.lastOrder === undefined) {
      await this.$store.dispatch('order/fetchOrders');
    }
    this.active = true;
  }

  get lastOrder(): SalesOrder | undefined {
    return this.$store.getters['order/lastOrder'];
  }

  get lastOrderDate(): string {
    if (this.lastOrder && this.lastOrder.PurchOrderDate) {
      const date = Helpers.getDateFromSapDate(this.lastOrder.PurchOrderDate);
      return format(date, 'dd-MM-yyyy');
    }

    return '';
  }
}
